import { CtaButtonType, CtaForm } from '@pairy/sheard/types';
import { useAtomValue } from 'jotai';

import { GetBulkFilePreviewResponse } from '../../../types/file';
import RootLayout from '../../@common/RootLayout';
import DesktopPageNavigation from '../../@common/PageNavigationDrawer/Desktop';
import BulkDesktopViewer from '../../BulkViewer/Desktop';
import { MessageBoxItemType } from '../../PdfViewer/index.types';
import { isPreviewFormSubmittedAtom } from '../index.atom';
import { getBlindPages } from '../../BulkViewer/index.util';
import useUpdateRenderThumbnails from '../../../hooks/useUpdateRenderThumbnails';

interface Props {
  data?: GetBulkFilePreviewResponse;
  messageBoxItems?: MessageBoxItemType[];
  ctaButtonList?: CtaButtonType[];
  ctaForm?: CtaForm;
  translateKoToEn: (item: string) => string;
}

const DesktopPdfPreview = ({
  data,
  messageBoxItems,
  ctaButtonList,
  ctaForm,
  translateKoToEn,
}: Props) => {
  if (!data) {
    return null;
  }

  const isSubmitted = useAtomValue(isPreviewFormSubmittedAtom);

  const pageNavigationInfo = data?.file?.thumbnails.map(
    ({ page, thumbnail, originalHeight, originalWidth, imageSources }) => {
      return {
        page,
        thumnail: thumbnail,
        originalHeight,
        originalWidth,
        imageSources,
      };
    },
  );

  const { file, user } = data;

  const blindStatus = ctaForm?.blind;
  const blindPage = ctaForm?.page;
  const blindPages = isSubmitted
    ? []
    : getBlindPages({
        blindStatus,
        blindPage,
        totalPages: pageNavigationInfo?.length,
      });

  const { updateNextThumbnails, updatePrevThumbnails } =
    useUpdateRenderThumbnails({
      defaultThumbnails: data?.file?.thumbnails,
    });

  return (
    <RootLayout mode="desktop">
      <DesktopPageNavigation
        fileName={data?.file.name}
        pages={pageNavigationInfo}
        translateKoToEn={translateKoToEn}
        blindPages={blindPages}
      />
      <BulkDesktopViewer
        file={file}
        user={{
          domain: user.domain,
          plan: user.plan,
          company: user.company,
        }}
        ctaForm={ctaForm}
        messageBoxItems={messageBoxItems}
        ctaButtonList={ctaButtonList}
        translateKoToEn={translateKoToEn}
        blindPages={blindPages}
        updateNextThumbnails={updateNextThumbnails}
        updatePrevThumbnails={updatePrevThumbnails}
        isPreview
      />
    </RootLayout>
  );
};

export default DesktopPdfPreview;
